import React from "react";
import { Icon, Box, Grid, Typography } from "@mui/material/";
import styles from "./styles";
import { strings } from "../../../../common/i18n";
import CheckAvatar from "../../../../common/components/CheckAvatar";
import NotesIcon from "@mui/icons-material/Notes";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ImageIcon from "@mui/icons-material/Image";

// Subcomponent for rendering exclusion details
const Detail = ({ label, text, Icon, type }) => (
    <Box display="flex" alignItems="flex-start" gap={1} py={1}>
        <Icon fontSize="small" color={type} sx={{ mt: 0.5 }} />
        <Box>
            <Typography
                variant="caption"
                fontWeight="bold"
                color="text.secondary"
            >
                {`${strings(label)} : `}
            </Typography>
            <Typography variant="caption" color="text.primary">
                {text}
            </Typography>
        </Box>
    </Box>
);

const AssetHistoryItem = ({ assetHistory }) => {
    const {
        user,
        note,
        exclusionReason,
        exclusionReasonDate,
        date,
        rejectionDate,
        heading,
        resolutionReason,
        imageType,
        systemActorKey
    } = assetHistory;

    const actorName = systemActorKey
        ? strings(systemActorKey)
        : user.nameKey
        ? strings(user.nameKey)
        : user.name;

    return (
        <Grid container spacing={3} key={date}>
            <Grid item xs={1}>
                <CheckAvatar
                    name={actorName}
                    url={user.avatarPath}
                    clsName={heading}
                />
            </Grid>

            <Grid item xs={5}>
                <Typography variant="button" sx={styles[heading]}>
                    {strings(heading)}
                </Typography>
                <Typography
                    component="div"
                    variant="caption"
                    sx={styles.historyTextStyle}
                >
                    {`${actorName} : `}
                </Typography>
                <Typography
                    variant="caption"
                    component="div"
                    sx={styles.historyTextStyle}
                >
                    {date}
                </Typography>
            </Grid>

            <Grid item xs={6}>
                {resolutionReason && (
                    <>
                        <Detail
                            label="reason"
                            text={resolutionReason}
                            Icon={DoneAllIcon}
                            type="info"
                        />
                        {rejectionDate && (
                            <Detail
                                label="rejectionDate"
                                text={rejectionDate}
                                Icon={CalendarTodayIcon}
                                type="primary"
                            />
                        )}
                    </>
                )}

                {exclusionReason && (
                    <Detail
                        label="reason"
                        text={exclusionReason.name}
                        Icon={ControlPointIcon}
                        type="error"
                    />
                )}

                {imageType && (
                    <Detail
                        label="type"
                        text={imageType}
                        Icon={ImageIcon}
                        type="info"
                    />
                )}

                {note && (
                    <Detail
                        label="note"
                        text={note}
                        Icon={NotesIcon}
                        type="info"
                    />
                )}

                {exclusionReasonDate && (
                    <Detail
                        label="date"
                        text={exclusionReasonDate}
                        Icon={CalendarTodayIcon}
                        type="primary"
                    />
                )}
            </Grid>
        </Grid>
    );
};

export default AssetHistoryItem;
